function CANdocs() {
  return (
    <iframe
      src="http://172.16.1.122"
      style={{
        width: '100%',
        height: 'calc(100vh - 64px)',
        border: 'none',
      }}
      title="StreamData Docs"
    />
  );
}

export default CANdocs;
